<template>
   <div class="form-group">
      <label
         for="ip_phone"
         :class="['label-overlay', { active: !isNotEmpty(form.phone) }]"
         @click="switchLabel($event)"
      >
         Phone
      </label>
      <input
         id="ip_phone"
         v-model.trim="form.phone"
         type="text"
         class="form-control"
         name="busPhone"
         :class="[
            { 'is-invalid': isValidPhoneNumber.isInvalid },
            { 'is-valid': isValidPhoneNumber.isValid },
         ]"
         @focus="switchLabel($event)"
         @blur="
            switchLabel($event);
            validatePhoneData();
            initiatedType();
         "
         @keypress="isNumber"
      />
      <small :class="['form-text optional-text', { active: !required && form.phone.length === 0 }]">
      </small>
      <div class="invalid-feedback">Please enter valid phone no.</div>
      <div class="valid-feedback">Sounds good.</div>
   </div>
</template>

<script>
import person from '../../../util/userData.js';

export default {
   name: 'PhoneComponent',
   props: {
      value: {
         type: String,
         default: '',
      },
      required: {
         type: Boolean,
         default: false,
      },
      options: {
         type: Object,
         default: null,
      },
   },
   data() {
      return {
         isValidPhoneNumber: {
            isValid: false,
            isInvalid: false,
         },
         form: {
            phone: this.value,
         },
         ...(process.browser && { userProfileTracker: this.$tracker.userProfile }),
         person,
         ...(process.browser && { tracker: this.$tracker.tracker }),
      };
   },

   mounted() {
      if (this.person.profileData) {
         this.form.phone = this.person.profileData.phone || '';
      }
   },
   methods: {
      validatePhoneData() {
         this.isValidPhoneNumber.isInvalid = this.$parent.attemptSubmit && this.wrongNumber;
         this.isValidPhoneNumber.isValid = !this.wrongNumber;
      },
      reset() {
         this.isValidPhoneNumber.isValid = false;
         this.form.phone = '';
      },

      initiatedType() {
         if (this.form.phone !== '') {
            this.userProfileTracker.information({ phone: this.form.phone });
         }

         if (
            typeof this.$parent.isFormInitiated === 'undefined' &&
            this.options &&
            this.options.mixpanelEve
         ) {
            this.$parent.isFormInitiated = true;
            this.tracker(this.options.mixpanelEve, {
               ...(this.options.name && { Name: this.options.name }),
               ...(this.options.type && { Type: this.options.type }),
               ...(this.options.product && { Product: this.options.product }),
               ...(this.options.framework && { Framework: this.options.framework }),
            });
         }
      },
   },
};
</script>

<style></style>
